import React from 'react';
import { useDispatch } from 'react-redux';

import { updateCustomFieldData } from 'containers/Leads/Lead/actions';
import FormBuilder from 'pages/BusinessSettings/Leads/components/CustomFields/FormBuilder';

const LeadRecordCustomFields = ({
  orgId,
  leadId,
  userDefinedFields,
}) => {
  const dispatch = useDispatch();
  const handleCustomFieldChange = async (id, urlId, fieldState) => {
    dispatch(updateCustomFieldData({ orgId, leadId, id, urlId, fieldState }));
  };

  return (
    <FormBuilder
      fields={userDefinedFields}
      onSubmit={handleCustomFieldChange}
    />
  );
};

export default LeadRecordCustomFields;
